export default __webpack_public_path__ + "static/media/1920.e2c580d6.png";